import { useCallback, useMemo } from "react";
import { MessageThreadFragment, MessageThreadType } from "gql/graphql";
import { useAuth } from "modules/providers/auth-provider";

const useRemovedFromThread = (messageThread?: MessageThreadFragment | null) => {
  const { me } = useAuth();
  const removedUserList = messageThread?.removedUserList;

  const removedUser = useMemo(
    () => removedUserList?.find((removedUser) => removedUser.userId === me?.id),
    [removedUserList, me?.id],
  );

  const isMeRemoved = useMemo(() => removedUser !== undefined, [removedUser]);

  const getCanRemoveUser = useCallback(
    (userId?: string | null) => {
      if (!userId || !messageThread) return false;
      if (isMeRemoved) return false;
      if (messageThread.type === MessageThreadType.Chat) return false;
      if (messageThread.isLocked) return false;
      if (!messageThread.accessUserIdList.includes(userId)) {
        return false;
      }
      if (messageThread.createMessageUserIdList.includes(userId)) {
        return false;
      }
      if (messageThread.task?.assignedUserId === userId) {
        return false;
      }
      return true;
    },
    [isMeRemoved, messageThread],
  );

  const canRemoveUser = useMemo(
    () => getCanRemoveUser(me?.id),
    [getCanRemoveUser, me?.id],
  );

  return { isMeRemoved, canRemoveUser, getCanRemoveUser, removedUser };
};

export default useRemovedFromThread;
